import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT, PM_MOVIES_EDITABLE_KEYS } from '../../constants/state'
import { updateFractalOrder } from './helpers'
import { toPmStartingDate } from '../../functions/pmStartingDate'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.pmMovies)


const updateEditableAttributes = (state, action) => {
    let item = state.getIn(['items', action.payload.pk])

    PM_MOVIES_EDITABLE_KEYS.map(key => {
        item = item.set(key, action.payload.itemData[key])
    })

    item = item.set('originalTitle', action.payload.itemData['origTitle'])
    item = item.set('visibleFrom', action.payload.itemData.limitations ? action.payload.itemData.limitations.visibleFrom : null)
    // The form hands over a JS Date when freshly picked, otherwise the string it
    // holds: the loaded "YYYY-MM-DD" day or a timestamp (pm or provider value
    // after a source switch). All become midnight of that day in the cinema's
    // own timezone (functions/pmStartingDate.js).
    item = item.set('startingDate', toPmStartingDate(action.payload.itemData.startingDate, action.payload.timezone))

    return state.setIn(['items', action.payload.pk], item)
}


// Start date only - the preview popup's write (#112). Every other field of the
// row stays as it is.
const updateStartingDate = (state, action) => state.setIn(
    ['items', String(action.payload.pk), 'startingDate'],
    toPmStartingDate(action.payload.startingDate, action.payload.timezone)
)

// Display title only - the meta merge's kept title (#113). Every other field of
// the row, the start date included, stays as stored.
const updateTitleDisplay = (state, action) => state.setIn(
    ['items', String(action.payload.pk), 'titleDisplay'],
    action.payload.titleDisplay
)



const pmMoviesReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PMMOVIES_UPDATE_ITEM_ORDER:
            return updateFractalOrder(state, action)
        case actionTypes.PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES:
            return updateEditableAttributes(state, action)
        case actionTypes.PMMOVIES_UPDATE_ITEM_STARTING_DATE:
            return updateStartingDate(state, action)
        case actionTypes.PMMOVIES_UPDATE_ITEM_TITLE_DISPLAY:
            return updateTitleDisplay(state, action)
        case actionTypes.TMDB_MATCH_SUCCESS: {
            const pmMovie = action.payload.pmMovie
            if (!pmMovie || !pmMovie.pk) return state
            return state.setIn(['items', String(pmMovie.pk)], fromJS(pmMovie))
        }
        default:
            return state;
    }
}

export default pmMoviesReducer;